import { Anchor, Container, Text, Title } from "@mantine/core";

export const Imprint = () => {
  return (
    <Container my="lg">
      <Title mb="xl">Impressum</Title>
      {/*
        Vorher „§5 TM" — gemeint war § 5 TMG. Das Telemediengesetz ist im
        Mai 2024 im Digitale-Dienste-Gesetz aufgegangen, die Impressumspflicht
        steht seitdem in § 5 DDG.
      */}
      <Text mb="lg">Angaben gemäß § 5 DDG</Text>
      <Text mb="lg">
        <strong>Inhaltlich verantwortlich ist</strong>
        <br />
        Hochschule Bielefeld
        <br />
        Fachbereich Gestaltung
        <br />
        Dekan Prof. Nils Hoff
        <br />
        +49 (0)521 106 7616
        <br />
        gestaltung@hsbi.de
        <br />
        Lampingstraße 3
        <br />
        33615 Bielefeld
        <br />
        Deutschland
      </Text>
      <Text>
        <strong>Impressum der Hochschule Bielefeld</strong>
        <br />
        <Anchor href="https://hsbi.de/impressum" target="_blank">
          hsbi.de/impressum
        </Anchor>
      </Text>
    </Container>
  );
};

export default Imprint;
